import { axiosGet } from "../../Helpers";

export const loadProfileInfo = async (setLoading) => {
  setLoading(true);
  let userId = JSON.parse(localStorage.getItem("userData"))?.id;
  console.log("userId", userId);
  const response = await axiosGet(`user/getUser/${userId}`);
  console.log("response", response);
  setLoading(false);
  const data = response.data?.data[0];
  console.log("data", data);

  return data;
};
